export default "__VITE_ASSET__DOPL_01w__"